import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { InfoBox } from './InfoBox';
import { CampaignModel } from 'src/domains/casino/state/AppCasino/store/campaign-store/CampaignModel';
import { CasinoGamesViewer } from './CasinoGamesViewer';
import { SportsViewer } from './SportsViewer';
import { useAppStateContext } from 'src/AppState/AppState';

const GeneralInfo = observer(
    'GeneralInfo',
    ({ campaignModel, bonusId }: { campaignModel: CampaignModel; bonusId: string }) => {
        console.log('walletData ', campaignModel);
        return (
            <div className='flex flex-col'>
                <h4 className='text-sm m-0 mb-2 font-semibold'>General Information</h4>
                <div className='mb-4'>
                    <h5 className='m-0 text-xs text-muted-foreground font-normal '>Reward Type</h5>
                    <span className='text-sm capitalize'>{campaignModel.bonusRewardTypeForView}</span>
                </div>
                <div className='mb-4'>
                    <h5 className='m-0 text-xs text-muted-foreground font-normal'>Reward Name</h5>
                    <span className='text-sm'>
                        {campaignModel.actionConditions?.bettingPlatform === null ? '-' : campaignModel.bonusRewardName}
                    </span>
                </div>
                <div className='mb-4'>
                    <h5 className='m-0 text-xs text-muted-foreground font-normal'>Reward ID</h5>
                    <span className='text-sm'>
                        {campaignModel.actionConditions?.bettingPlatform === null ? '-' : bonusId}
                    </span>
                </div>
                <div>
                    <h5 className='text-sm m-0 mb-2 font-semibold'>Scheduling</h5>
                    <div className='flex flex-row'>
                        <div className='w-1/2'>
                            <h5 className='m-0 text-xs text-muted-foreground font-normal'>Instalment Count</h5>

                            <span className='text-sm'>{campaignModel.installmentCount ?? 'N/A'}</span>
                        </div>
                        <div className='w-1/2'>
                            <h5 className='m-0 text-xs text-muted-foreground font-normal'>Reward Interval</h5>

                            <span className='text-sm'>{campaignModel.rewardInterval ?? 'N/A'}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
);

const FreeBetsExpiryAndCriteria = observer(
    'FreeBetsExpiryAndCriteria',
    ({ campaignModel, userId }: { campaignModel: CampaignModel; userId: number }) => {
        const { models } = useAppStateContext();
        const walletData = models.getUserModel(userId).walletData.data;
        if (walletData === null) return null;
        return (
            <div className='flex flex-col'>
                <h4 className='text-sm m-0 mb-2 font-semibold'>Betting Types & Odds Criteria</h4>
                <div className='mb-4'>
                    <h5 className='m-0 text-xs text-muted-foreground font-normal'>Bet Type</h5>
                    <span className='text-sm capitalize'>{campaignModel.bonusRewardBetType}</span>
                    <div className='flex flex-row'>
                        <div className='w-1/2'>
                            <h5 className='m-0 text-xs text-muted-foreground font-normal'>Reward Value</h5>

                            <span className='text-sm'>
                                {campaignModel.rewardAmount.map((amount) =>
                                    amount?.div(100).format(walletData.currency, { withoutZeros: true })
                                )}
                            </span>
                        </div>
                        <div className='w-1/2'>
                            <h5 className='m-0 text-xs text-muted-foreground font-normal'>Min Odds</h5>
                            <span className='text-sm'>{campaignModel.bonusRewardMinOdds}</span>
                        </div>
                    </div>
                </div>
                <div className='flex flex-col'>
                    <h4 className='text-sm m-0 mb-2 font-semibold'>Reward Expiry</h4>

                    <div className='flex flex-row'>
                        <div className='w-1/2'>
                            <h5 className='m-0 text-xs text-muted-foreground font-normal'>Expiry</h5>

                            <span className='text-sm'>{campaignModel.expiryTypeForView?.expiryType}</span>
                        </div>
                        <div className='w-1/2'>
                            <h5 className='m-0 text-xs text-muted-foreground font-normal'>
                                {campaignModel.expiryTypeForView?.labelInfo}
                            </h5>
                            <span className='text-sm'>
                                {campaignModel.bonusRewardExpiryDate?.format('DD/MM/YYYY | HH:mm')} <br />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
);

const FreeSpinsExpiryAndCriteria = observer(
    'FreeSpinsExpiryAndCriteria',
    ({ campaignModel }: { campaignModel: CampaignModel }) => {
        return (
            <div className='flex flex-col'>
                <div className='flex flex-col'>
                    <h4 className='text-sm m-0 mb-2 font-semibold'>Reward Expiry</h4>

                    <div className='flex flex-row mb-4'>
                        <div className='w-1/2'>
                            <h5 className='m-0 text-xs text-muted-foreground font-normal'>Expiry</h5>

                            <span className='text-sm'>{campaignModel.expiryTypeForView?.expiryType}</span>
                        </div>
                        <div className='w-1/2'>
                            <h5 className='m-0 text-xs text-muted-foreground font-normal'>
                                {campaignModel.expiryTypeForView?.labelInfo}
                            </h5>
                            <span className='text-sm'>
                                <span className='font-semibold'>{campaignModel.bonusRewardRelativeExpiryDays}</span>
                            </span>
                        </div>
                    </div>

                    <h4 className='text-sm m-0 mb-2 font-semibold'>Reward Criteria</h4>
                    <div className='flex flex-row'>
                        <div className='w-1/2'>
                            <div className='mb-4'>
                                <h5 className='m-0 text-xs text-muted-foreground font-normal'>Type</h5>
                                <span className='text-sm capitalize'>
                                    {campaignModel.bonusRewardTypeForView.toString()}
                                </span>
                            </div>
                            <div>
                                <h5 className='m-0 text-xs text-muted-foreground font-normal'>Total Bet</h5>
                                <span className='text-sm'>{campaignModel.totalBet}</span>
                            </div>
                        </div>
                        <div className='w-1/2'>
                            <h5 className='m-0 text-xs text-muted-foreground font-normal'>Number of Free Spins</h5>
                            <span className='text-sm'>{campaignModel.rewardAmount[0]?.value}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
);

interface RewardConditionPropsType {
    campaignModel: CampaignModel;
    userId: number;
    bonusId: string;
}

export const RewardCondition = observer(
    'RewardCondition',
    ({ campaignModel, userId, bonusId }: RewardConditionPropsType) => {
        if (campaignModel.bonusRewardType === null) {
            return null;
        }

        return (
            <InfoBox>
                <h3 className='m-0 mb-4 text-base font-semibold'>Reward Conditions</h3>
                <div className='flex gap-8 mb-4'>
                    <div className='w-1/2'>
                        <GeneralInfo
                            campaignModel={campaignModel}
                            bonusId={bonusId}
                        />
                    </div>
                    <div className='w-1/2'>
                        {campaignModel.bonusRewardType === 'free-bet' ? (
                            <FreeBetsExpiryAndCriteria
                                campaignModel={campaignModel}
                                userId={userId}
                            />
                        ) : (
                            <FreeSpinsExpiryAndCriteria campaignModel={campaignModel} />
                        )}
                    </div>
                </div>
                {campaignModel.bonusRewardType === 'free-bet' ? (
                    <>
                        <h4 className='text-sm m-0 mb-2 font-semibold'>
                            Eligible: Sport &gt; Competition &gt; Event &gt; Market
                        </h4>
                        <SportsViewer
                            campaignModel={campaignModel}
                            type='reward-conditions'
                        />
                    </>
                ) : (
                    <>
                        <h4 className='text-sm m-0 mb-2 font-semibold'>Free Spins Eligible Games</h4>
                        <CasinoGamesViewer
                            campaignModel={campaignModel}
                            type='eligible-games'
                        />
                        <h4 className='text-sm mb-2 mt-4 font-semibold'>Free Spins Eligible Games</h4>
                        <div>
                            <h5 className='m-0 text-xs text-muted-foreground font-normal'>Playthrough</h5>
                            <span className='text-sm mb-3 block'>{campaignModel.playthrough ?? '-'} </span>
                            <h5 className='mb-2 mt-0 text-xs text-muted-foreground font-normal'>
                                Playthrough Eligible Games
                            </h5>
                        </div>
                        <CasinoGamesViewer
                            campaignModel={campaignModel}
                            type='playthrough-games'
                        />
                    </>
                )}
            </InfoBox>
        );
    }
);
